/* ============================================================
   Conversion tracking (loaded on every page).

   GA4 events, sent with gtag (G-FHS2HGKYLR):
     click_to_call   a tel: link was tapped
     whatsapp_click  a WhatsApp chat link was tapped (not share buttons)
     generate_lead   an enquiry was sent (fired on thank-you.html, once per
                     reference number)

   Each event is also pushed to the dataLayer as "sktw_<event>" so GTM
   (GTM-MBLKGFP6) can use it, e.g. as a Google Ads conversion trigger.
   The prefix keeps GTM triggers separate from the GA4 events above, so
   a GTM tag can't count them a second time by accident.

   No personal data is sent: only the page, link type and enquiry type.
   ============================================================ */
(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  function track(name, params) {
    params.page_path = window.location.pathname;
    if (typeof window.gtag === 'function') window.gtag('event', name, params);
    window.dataLayer.push(Object.assign({ event: 'sktw_' + name }, params));
  }

  // Calls and WhatsApp chats: one listener for every link on the page.
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href]');
    if (!link) return;
    var href = link.getAttribute('href') || '';

    if (href.indexOf('tel:') === 0) {
      track('click_to_call', { phone_number: href.slice(4), link_text: link.textContent.trim().slice(0, 60) });
    } else if (/wa\.me\/\d/.test(href)) {
      track('whatsapp_click', { link_text: link.textContent.trim().slice(0, 60) });
    }
  }, true);

  // Enquiry sent: the forms redirect to thank-you.html?ref=...&type=...
  if (/\/thank-you\.html$/.test(window.location.pathname)) {
    var params = new URLSearchParams(window.location.search);
    var ref = params.get('ref') || '';
    var type = params.get('type') || 'contact';
    if (!/^SKTW-\d{6}-[0-9A-F]{6}$/.test(ref)) return;

    // Count each enquiry once, even if the thank-you page is reloaded.
    var key = 'sktw_lead_' + ref;
    try {
      if (window.sessionStorage.getItem(key)) return;
      window.sessionStorage.setItem(key, '1');
    } catch (err) { /* storage blocked: still count it */ }

    track('generate_lead', { form_type: type, lead_ref: ref });
  }
})();
